module.exports = __webpack_public_path__ + "img/humpback-whale.6b99b3f7.png";